import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

export interface ConfirmDialogOptions {
  confirmButtonTextTranslationKey?: string;
  cancelButtonTextTranslationKey?: string;
  thirdButtonTextTranslationKey?: string;
  thirdButtonClass?: string;
  thirdFn?: () => void;
}

@Injectable()
export class ConfirmDialogService {
  private subject = new Subject<any>();

  constructor() {
  }

  confirmThis(message: string, siFn: () => void, noFn: () => void, options?: ConfirmDialogOptions) {
    this.setConfirmation(message, siFn, noFn, options);
  }

  setConfirmation(message: string, siFn: () => void, noFn: () => void, options?: ConfirmDialogOptions) {
    let that = this;
    this.subject.next({
      type: "confirm",
      text: message,
      confirmButtonTextTranslationKey: options?.confirmButtonTextTranslationKey || "SHARED.CONFIRM",
      cancelButtonTextTranslationKey: options?.cancelButtonTextTranslationKey || "SHARED.CANCEL",
      thirdButtonTextTranslationKey: options?.thirdButtonTextTranslationKey,
      thirdButtonClass: options?.thirdButtonClass || "btn btn-default",
      siFn:
        function () {
          that.subject.next(); // this will close the modal
          siFn();
        },
      thirdFn: options?.thirdFn
        ? function () {
          that.subject.next();
          options.thirdFn();
        }
        : null,
      noFn: function () {
        that.subject.next();
        noFn();
      }
    });

  }

  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }
}
